<mat-toolbar color="primary" class="toolbar">
  <a mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
    <mat-icon>more_vert</mat-icon>
  </a>
  <mat-menu #menu="matMenu">
    <a mat-menu-item (click)="gotoQuestionnaire()" *ngIf="questionnaireVisible">
      <mat-icon>feed</mat-icon>
      <span>Questionnaire</span>
    </a>
    <a mat-menu-item (click)="gotoPay()" *ngIf="paymentVisible">
      <mat-icon>credit_card</mat-icon>
      <span>Payment</span>
    </a>
    <a mat-menu-item (click)="gotoSign()" *ngIf="signVisible">
      <mat-icon>create</mat-icon>
      <span>Sign</span>
    </a>
  </mat-menu>
  <img src="../assets/img/mgis/MGIS2.png" alt="MGIS Logo" class="logo" />
  <div class="toolbar-inner-quote">High Limits Disability Insurance Application</div>
</mat-toolbar>

<div class="app-progress">
  <div class="app-progress-inner">Application Progress</div>
  <ngb-progressbar class="mb-3 progress-bar custom-blue-bar" [showValue]="true" [value]="percent"></ngb-progressbar>
</div>

<div class="page-background-quote">
  <br />
  <div class="quote">
    <div class="estimate">
      <div class="">
        <h4 class="estimate-text">Annual Price Estimate*</h4>
        <h4 class="estimate-value-text">{{ totalAnnualAmount | currency }}</h4>
        <div class="estimate-info">
          Coverage options are displayed below. Your Annual Price Estimate will be updated to reflect any
          coverage changes you make, if available. When ready, click 'Apply Now' to continue your
          application.
        </div>
      </div>

      <div class="monthly-benefit">
        <mat-form-field>
          <mat-label>Monthly Benefit</mat-label>
          <mat-select matNativeControl [(ngModel)]="TTDselectedBenefit" (ngModelChange)="refreshPlan()">
            @for (item of monthlyBenefitOptions; track item) {
              <mat-option [value]="item">{{ item | currency }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="elimination-period">
        <mat-form-field>
          <mat-label>Elimination Period</mat-label>
          <mat-select matNativeControl [(ngModel)]="eliminationPeriod" (ngModelChange)="refreshPlan()">
            @for (item of eliminationPeriodOptions; track item) {
              <mat-option [value]="item">{{ item }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="additional-benefits-outer">
        <div class="additional-benefits">
          <div class="additional-benefits-inner">
            <h4 class="benefit-text">Additional Benefits:</h4>

            <div class="benefit-details" *ngIf="COLAInclusion != 'N'">
              <mat-checkbox
                [disabled]="COLAInclusion === 'Y'"
                [disabledInteractive]="COLAInclusion === 'Y'"
                [(ngModel)]="COLA"
                (ngModelChange)="onCOLAChange($event)"
                class="additional-benefit"
              >
                <span class="benefit-label">Cost of Living Benefit</span>
              </mat-checkbox>
              <div class="additional-benefit choices" *ngIf="COLADuration">Duration: {{ COLADuration }}</div>
            </div>

            <div class="benefit-details" *ngIf="IDRInclusion != 'N'">
              <mat-checkbox
                [disabled]="IDRInclusion === 'Y'"
                [disabledInteractive]="IDRInclusion === 'Y'"
                [(ngModel)]="IDR"
                (ngModelChange)="onIDRChange($event)"
                class="additional-benefit"
              >
                <span class="benefit-label">Infectious & Contagious Disease Benefit</span>
              </mat-checkbox>
              <div class="additional-benefit choices" *ngIf="IDRDuration">Duration: {{ IDRDuration }}</div>
            </div>

            <div class="benefit-details" *ngIf="EEBInclusion != 'N'">
              <mat-checkbox
                [disabled]="EEBInclusion === 'Y'"
                [disabledInteractive]="EEBInclusion === 'Y'"
                [(ngModel)]="EEB"
                (ngModelChange)="onEEBChange($event)"
                class="additional-benefit"
              >
                <span class="benefit-label">Extended Earnings Benefit</span>
              </mat-checkbox>
              <div class="additional-benefit choices" *ngIf="EEBDuration">Duration: {{ EEBDuration }}</div>
            </div>

            <div class="benefit-details" *ngIf="SLRInclusion != 'N'">
              <mat-checkbox
                [disabled]="SLRInclusion === 'Y'"
                [disabledInteractive]="SLRInclusion === 'Y'"
                [(ngModel)]="SLR"
                (ngModelChange)="onSLRChange($event)"
                class="additional-benefit"
              >
                <span class="benefit-label">Student Loan Repayment Benefit</span>
              </mat-checkbox>
              <div class="additional-benefit choices" *ngIf="SLRAmount">
                Amount: {{ SLRAmount | currency }}<br />
                Duration: {{ SLRDuration }}
              </div>
            </div>

            <div class="benefit-details" *ngIf="PLPInclusion != 'N'">
              <mat-checkbox
                [disabled]="PLPInclusion === 'Y'"
                [disabledInteractive]="PLPInclusion === 'Y'"
                [(ngModel)]="PLP"
                (ngModelChange)="onPLPChange($event)"
                class="additional-benefit"
              >
                <span class="benefit-label">Professional Liability Premium Benefit</span>
              </mat-checkbox>
              <div class="additional-benefit choices" *ngIf="PLPAmount">
                Amount: {{ PLPAmount | currency }}<br />
                Duration: {{ PLPDuration }}
              </div>
            </div>

            <div class="benefit-details" *ngIf="RCBInclusion != 'N'">
              <mat-checkbox
                [disabled]="RCBInclusion === 'Y'"
                [disabledInteractive]="RCBInclusion === 'Y'"
                [(ngModel)]="RCB"
                (ngModelChange)="onRCBChange($event)"
                class="additional-benefit"
              >
                <span class="benefit-label">Retirement Contribution Benefit</span>
              </mat-checkbox>
              <div class="additional-benefit choices" *ngIf="RCBAmount">
                Amount: {{ RCBAmount | currency }}<br />
                Duration: {{ RCBDuration }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="additional-benefits-area">
        <div class="small-text">*Includes Premium, Taxes, and Fees. Taxes are subject to change each year.</div>
      </div>

      <div class="apply-now">
        <button class="button-mgis-quote" (click)="applyNow()" mat-flat-button>Apply Now</button>
      </div>
    </div>
  </div>
</div>
